import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import SamlCallback from "./pages/auth/SamlCallback";
import SamlFailure from "./pages/auth/SamlFailure";
import TeacherDashboard from "./pages/TeacherDashboard/TeacherDashboard";
import StudentDashboard from "./pages/StudentDashboard/StudentDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "react-hot-toast";
import LecturePanel from "./pages/lecture/LecturePanel";
import AssignmentViewer from "./pages/Assignment/teacher/AssignmentViewer.jsx";
import TeacherAssignmentGrading from "./pages/Assignment/teacher/TeacherAssignmentGrading.jsx";
import ActivityViewer from "./pages/Activity/teacher/ActivityViewer.jsx";
import { CourseProvider } from "./context/CourseContext.js";
import EContentViewer from "./pages/Econtent/EcontentViewer.jsx";
import TeacherProfilePage from "./pages/TeacherDashboard/Components/TeacherProfile/TeacherProfilePage.jsx";

import StudentAssignmentSection from "./pages/Assignment/student/ShowAssignment.jsx";
import CourseDetails from "./pages/course/student/CourseDetails.jsx";
import UtilityProvider, { useUtilityContext } from "./context/UtilityContext.js";
import TeacherProfileSection from "./pages/TeacherDashboard/Components/TeacherProfile/TeacherProfileSection.jsx";
import ITS from "./pages/Its/Its.jsx";
import { MeetingV2Provider } from "./context/MeetingV2Context.js";
const App = () => {
   useEffect(() => {
  const theme = localStorage.getItem("theme") || "light";
  if (theme === "dark") {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}, []);
  return (
    <AuthProvider>
      <UtilityProvider>
        <CourseProvider>
          <MeetingV2Provider>
          <Router>
            <Layout />
          </Router>
          <Toaster position="top-right" reverseOrder={false} />
          </MeetingV2Provider>
        </CourseProvider>
      </UtilityProvider>
    </AuthProvider>
  );
};
const RootRedirect = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === "teacher") {
    return <Navigate to="/teacher/dashboard" replace />;
  }

  if (user.role === "student") {
    return <Navigate to="/student/dashboard" replace />;
  }

  if (user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  return <Navigate to="/login" replace />;
};

/** Redirect /teacher/course/:courseID → dashboard with sidebar (inline mode) */
const TeacherCourseRedirect = () => {
  const { courseID } = useParams();
  const { setSelectedCourseId, setActiveSection } = useUtilityContext();

  useEffect(() => {
    if (courseID) {
      setSelectedCourseId(courseID);
      setActiveSection("Courseware");
    }
  }, [courseID, setSelectedCourseId, setActiveSection]);

  return <Navigate to="/teacher/dashboard" replace />;
};

const Layout = () => {
  const location = useLocation();
  const hideNavbarRoutes = ["/login", "/register", "/auth/saml/callback", "/auth/saml/failure"];

  return (
    <div className="min-h-screen dark:bg-gray-900 bg-white">
      {/* Conditionally render Navbar */}
      {/* {!hideNavbarRoutes.includes(location.pathname) && <Navbar />} */}

      <main className="mx-auto">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/saml/callback" element={<SamlCallback />} />
          <Route path="/auth/saml/failure" element={<SamlFailure />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute roles={["admin"]}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/dashboard"
            element={
              <PrivateRoute roles={["teacher"]}>
                <TeacherDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/assignment/:assignmentID"
            element={
              <PrivateRoute roles={["teacher"]}>
                <AssignmentViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/assignment/:assignmentId/grade"
            element={
              <PrivateRoute roles={["teacher"]}>
                <TeacherAssignmentGrading />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/activity/:activityID"
            element={
              <PrivateRoute roles={["teacher"]}>
                <ActivityViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/econtent/:courseId"
            element={
              <PrivateRoute roles={["teacher"]}>
                <EContentViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/dashboard"
            element={
              <PrivateRoute roles={["student"]}>
                <StudentDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/teacher/profile/:teacherID"
            element={
              <PrivateRoute roles={["teacher"]}>
                <TeacherProfileSection />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/course/:courseID"
            element={
              <PrivateRoute roles={["student"]}>
                <CourseDetails />
              </PrivateRoute>
            }
          />
           <Route
            path="/its"
            element={
              <PrivateRoute roles={["student"]}>
                <ITS />
              </PrivateRoute>
            }
          />

          <Route
            path="/teacher/course/:courseID"
            element={
              <PrivateRoute roles={["teacher"]}>
                <TeacherCourseRedirect />
              </PrivateRoute>
            }
          />

          <Route
            path="/lectures/:courseID/:selectedID"
            element={
              <PrivateRoute>
                <LecturePanel />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
